import gql from 'graphql-tag';

export const MUTATE_AGREEMENTS = gql`
  mutation updateNlabelAgreements($isAgreed: Boolean!, $bookingUrl: String) {
    updateNlabelAgreements(isAgreed: $isAgreed, bookingUrl: $bookingUrl) {
      isSuccess
    }
  }
`;
